import serviceRequest from "utils/request";

const baseUrl = "/api/user";

export const signup = (param) => {
	return serviceRequest({
		url: `${baseUrl}/signup/v3`,
		method: "post",
		data: param,
	});
};
